import { Chip, Stack } from "@mui/material";
import React from "react";
import { Badge } from "react-bootstrap";

import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export const CompanyInformations = ({ company }) => {
  const { t } = useTranslation();
  const user = useSelector((state) => state.authentication.user);

  return (
    <div className="company__informations">
      <h3 className="page-subtitle">{t("Informations")}</h3>

      <p>
        {t("Address")} : {company?.address1}
      </p>
      {/* <p>
        {t("Zipcode")} : {company?.zipCode}
      </p>
      <p>
        {t("City")} : {company?.city}
      </p>
      <p>
        {t("Country")} : {company?.country}
      </p> */}
      <p>
        {t("MYBAid")} : {company?.MYBAid}
      </p>
      <p>
        {t("Registration Number")} : {company?.registrationNumber}
      </p>
      {/* <p>
        {t("Registration Country")} : {company?.registrationCountry}
      </p> */}
      <p>
        {t("VAT Number")}: {company?.VATnumber}
      </p>
      <p>
        {t("Insurance")} : {company?.insurance}
      </p>
      <p>
        {t("Financial Guarantee")} : {company?.financialGuarantee}
      </p>
      <p>
        {t("ECPY Id")} : {company?.ecpyId}
      </p>
      {user?.roles.includes("ROLE_ADMIN") && (
        <div className="d-flex">
          <p>{t("Agreements")} : </p>
          <Stack direction="row" spacing={0.3}>
            {company?.cdtPermit && (
              <Chip label="Transport" color="primary" size="small" />
            )}
            {company?.cdcPermit && (
              <Chip label="Charter" color="primary" size="small"/>
            )}
          </Stack>
        </div>
      )}
    </div>
  );
};
